<script>
import Layout from '@layouts/auth'
import { authMethods } from '@state/helpers'
import getSecret from '@utils/get-secret'
import DisableAutocomplete from 'vue-disable-autocomplete'
import Vue from 'vue'
Vue.use(DisableAutocomplete);

export default {
  page: {
    title: 'Log in',
    meta: [{ name: 'description', content: `Log in to ${getSecret('TITLE')}` }] // Used in a html meta tag,
  },
  components: { Layout },
  data() {
    return {
      username: '',
      password: '',
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      hidePassword: true,
    }
  },
  computed: {
    getCompanyInfo: function () {
      return this.$store.state.appAuth.companyInfo || null
    },
    passwordType() {
      return this.hidePassword ? 'password' : 'text'
    },
    passwordIcon() {
      return this.hidePassword ? 'fa-eye' : 'fa-eye-slash'
    },
  },
  mounted(){
    if (this.$route.params && 'expiredSession' in this.$route.params){
      this.$generate_toast(this, 'error', this.$t('expired_session'))
    }
    if ('redirectFrom' in this.$route.query && this.$route.query.redirectFrom !== '/home'){
      this.$generate_toast(this, 'error', this.$t('login_required'))
    }
  },
  methods: {
    //  unzip helper methods saved in Vuex
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.tryingToLogIn = true
      // Reset the authError if it existed.
      this.authError = null
        return this.logIn({
          username: this.username,
        password: this.password,
      })
        .then((token) => {
          this.tryingToLogIn = false
          this.isAuthError = false
          // Redirect to the originally requested page, or to the home page
          let redirectPath =  this.$route.query.redirectFrom ? this.$route.query.redirectFrom === '/logout' ? null : this.$route.query.redirectFrom : null 
          this.$router.push(redirectPath || { name: 'home' })
        })
        .catch((error) => {
          this.tryingToLogIn = false
          this.authError = error.response? error.response.data.non_field_errors[0] : error.message
          this.isAuthError = true
        })
    },
    removeReadonly(event){
      event.preventDefault()
      if(event.target.getAttribute('readonly') == 'readonly'){
          event.target.removeAttribute('readonly')
      }
    }
  },
}
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card bg-pattern">
          <div class="card-body p-4 pb-0">
            <div class="text-center m-auto">
              <a href="/"> 
                <span
                  ><img
                    v-if="getCompanyInfo && getCompanyInfo.light_logo"
                    :src="getCompanyInfo.dark_logo || require('@assets/images/logos/euro-logo.svg')"
                    alt="login" height="120"
                    style="max-width: 100%;"
                  /></span>
              </a>
              <p class="text-muted mb-4 mt-3"
                > {{ $t('login_section.init_msg') }}</p>
            </div>

            <b-alert v-if="!tryingToLogIn" v-model="isAuthError" variant="danger" dismissible>
              {{authError}}
            </b-alert>

            <b-form @submit.prevent="tryToLogIn">
              <b-form-group
                id="input-group-1"
                :label="$t('email_or_username')"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="username"
                  ref="username"
                  type="text"
                  required
                  placeholder="Ingrese usuario"
                  autocomplete="off"
                  @focusin="removeReadonly" 
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="password-group"
                label-for="register-password"
                class="mb-2 mr-sm-2 mb-sm-2 md-6 lg-6"
              >
                <slot name="label">
                  <label class="d-block">Contraseña <i class="fas" :class="[passwordIcon]" @click="hidePassword = !hidePassword"></i></label>
                </slot>
                <b-form-input
                  id="input-2"
                  v-model="password"
                  :type="passwordType"
                  required
                  placeholder="Ingresa la contraseña"
                  autocomplete="off"
                  @focusin="removeReadonly"
                ></b-form-input>
              </b-form-group>

              <b-form-group id="button-group" class="mt-4 mb-0">
                <b-button
                  type="submit"
                  variant="primary"
                  class="btn-block waves-effect"
                  :disabled="tryingToLogIn"
                  >
                  <span
                    v-if="!tryingToLogIn"
                    >
                    {{ $t('login') }}
                  </span>
                  <b-spinner
                    v-if="tryingToLogIn"
                    small
                    label="Spinning"
                    variant="light"
                    >
                  </b-spinner>
                </b-button
                >
              </b-form-group>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

         <div class="row mt-3">
          <div class="col-12 text-center">
            <p>
              <router-link tag="a" to="/forget-password" class="text-white-50 ml-1">
                {{ $t('login_section.forgot_your_password') }}
              </router-link>
            </p>
            
            <!-- <p class="text-white-50"
              >{{ $t('login_section.dont_have_an_account') }}
              <router-link tag="a" to="/register" class="text-white ml-1"><b>{{ $t('login_section.sign_up') }}</b></router-link>
            </p> -->
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
